import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useTranslation } from "react-i18next";
import { ChartDataPoint } from "@/hooks/useSubscriptionStats";

interface SubscriptionChartProps {
  data: ChartDataPoint[];
}

export function SubscriptionChart({ data }: SubscriptionChartProps) {
  const { t } = useTranslation();

  return (
    <div className="rounded-xl border-2 border-black bg-white p-8 shadow-[4px_4px_0_#000] h-full">
      <h3 className="mb-6 text-2xl font-black tracking-tight">{t('admin.sales.chart.title')}</h3>
      <div className="h-[350px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data}>
            <defs>
              <linearGradient id="colorCount" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#FF6B9D" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#FF6B9D" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
            <XAxis 
              dataKey="date" 
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#6B7280', fontSize: 12 }}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#6B7280', fontSize: 12 }}
            />
            <Tooltip 
              contentStyle={{ 
                borderRadius: '8px', 
                border: '2px solid black',
                boxShadow: '4px 4px 0px rgba(0,0,0,1)'
              }}
            />
            <Area
              type="monotone"
              dataKey="count"
              name={t('admin.sales.chart.subscribers')}
              stroke="#FF6B9D"
              strokeWidth={3}
              fillOpacity={1}
              fill="url(#colorCount)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
